export function makeId(string) {
  return string.replace(/\W/g, "");
}
